export default {"src":"/login-app/[GIT_HASH]/_next/static/media/infinity.ed1b8e19.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};